function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

function createCancelError() {
  return new Error('Cancelled');
}

var _activeRequests = /*#__PURE__*/_classPrivateFieldLooseKey("activeRequests");

var _queuedHandlers = /*#__PURE__*/_classPrivateFieldLooseKey("queuedHandlers");

var _paused = /*#__PURE__*/_classPrivateFieldLooseKey("paused");

var _pauseTimer = /*#__PURE__*/_classPrivateFieldLooseKey("pauseTimer");

var _downLimit = /*#__PURE__*/_classPrivateFieldLooseKey("downLimit");

var _upperLimit = /*#__PURE__*/_classPrivateFieldLooseKey("upperLimit");

var _rateLimitingTimer = /*#__PURE__*/_classPrivateFieldLooseKey("rateLimitingTimer");

var _call = /*#__PURE__*/_classPrivateFieldLooseKey("call");

var _queueNext = /*#__PURE__*/_classPrivateFieldLooseKey("queueNext");

var _next = /*#__PURE__*/_classPrivateFieldLooseKey("next");

var _queue = /*#__PURE__*/_classPrivateFieldLooseKey("queue");

var _dequeue = /*#__PURE__*/_classPrivateFieldLooseKey("dequeue");

var _resume = /*#__PURE__*/_classPrivateFieldLooseKey("resume");

var _increaseLimit = /*#__PURE__*/_classPrivateFieldLooseKey("increaseLimit");

var RateLimitedQueue = /*#__PURE__*/function () {
  function RateLimitedQueue(limit) {
    var _this2 = this;

    _classCallCheck(this, RateLimitedQueue);

    Object.defineProperty(this, _dequeue, {
      value: _dequeue2
    });
    Object.defineProperty(this, _queue, {
      value: _queue2
    });
    Object.defineProperty(this, _next, {
      value: _next2
    });
    Object.defineProperty(this, _queueNext, {
      value: _queueNext2
    });
    Object.defineProperty(this, _call, {
      value: _call2
    });
    Object.defineProperty(this, _activeRequests, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _queuedHandlers, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _paused, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _pauseTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _downLimit, {
      writable: true,
      value: 1
    });
    Object.defineProperty(this, _upperLimit, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _rateLimitingTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _resume, {
      writable: true,
      value: function value() {
        return _this2.resume();
      }
    });
    Object.defineProperty(this, _increaseLimit, {
      writable: true,
      value: function value() {
        if (_classPrivateFieldLooseBase(_this2, _paused)[_paused]) {
          _classPrivateFieldLooseBase(_this2, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase(_this2, _increaseLimit)[_increaseLimit], 0);
          return;
        }

        _classPrivateFieldLooseBase(_this2, _downLimit)[_downLimit] = _this2.limit;
        _this2.limit = Math.ceil((_classPrivateFieldLooseBase(_this2, _upperLimit)[_upperLimit] + _classPrivateFieldLooseBase(_this2, _downLimit)[_downLimit]) / 2);

        for (var i = _classPrivateFieldLooseBase(_this2, _downLimit)[_downLimit]; i <= _this2.limit; i++) {
          _classPrivateFieldLooseBase(_this2, _queueNext)[_queueNext]();
        }

        if (_classPrivateFieldLooseBase(_this2, _upperLimit)[_upperLimit] - _classPrivateFieldLooseBase(_this2, _downLimit)[_downLimit] > 3) {
          _classPrivateFieldLooseBase(_this2, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase(_this2, _increaseLimit)[_increaseLimit], 2000);
        } else {
          _classPrivateFieldLooseBase(_this2, _downLimit)[_downLimit] = Math.floor(_classPrivateFieldLooseBase(_this2, _downLimit)[_downLimit] / 2);
        }
      }
    });

    if (typeof limit !== 'number' || limit === 0) {
      this.limit = Infinity;
    } else {
      this.limit = limit;
    }
  }

  _createClass(RateLimitedQueue, [{
    key: "run",
    value: function run(fn, queueOptions) {
      if (!_classPrivateFieldLooseBase(this, _paused)[_paused] && _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] < this.limit) {
        return _classPrivateFieldLooseBase(this, _call)[_call](fn);
      }

      return _classPrivateFieldLooseBase(this, _queue)[_queue](fn, queueOptions);
    }
  }, {
    key: "wrapPromiseFunction",
    value: function wrapPromiseFunction(fn, queueOptions) {
      var _this = this;

      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var queuedRequest;
        var outerPromise = new Promise(function (resolve, reject) {
          queuedRequest = _this.run(function () {
            var cancelError;
            var innerPromise;

            try {
              innerPromise = Promise.resolve(fn.apply(void 0, args));
            } catch (err) {
              innerPromise = Promise.reject(err);
            }

            innerPromise.then(function (result) {
              if (cancelError) {
                reject(cancelError);
              } else {
                queuedRequest.done();
                resolve(result);
              }
            }, function (err) {
              if (cancelError) {
                reject(cancelError);
              } else {
                queuedRequest.done();
                reject(err);
              }
            });
            return function () {
              cancelError = createCancelError();
            };
          }, queueOptions);
        });

        outerPromise.abort = function () {
          queuedRequest.abort();
        };

        return outerPromise;
      };
    }
  }, {
    key: "resume",
    value: function resume() {
      _classPrivateFieldLooseBase(this, _paused)[_paused] = false;
      clearTimeout(_classPrivateFieldLooseBase(this, _pauseTimer)[_pauseTimer]);

      for (var i = 0; i < this.limit; i++) {
        _classPrivateFieldLooseBase(this, _queueNext)[_queueNext]();
      }
    }
    /**
     * Freezes the queue for a while or indefinitely.
     *
     * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
     *                                    If omitted, the queue won't resume automatically.
     */

  }, {
    key: "pause",
    value: function pause(duration) {
      if (duration === void 0) {
        duration = null;
      }

      _classPrivateFieldLooseBase(this, _paused)[_paused] = true;
      clearTimeout(_classPrivateFieldLooseBase(this, _pauseTimer)[_pauseTimer]);

      if (duration != null) {
        _classPrivateFieldLooseBase(this, _pauseTimer)[_pauseTimer] = setTimeout(_classPrivateFieldLooseBase(this, _resume)[_resume], duration);
      }
    }
    /**
     * Pauses the queue for a duration, and lower the limit of concurrent requests
     * when the queue resumes. When the queue resumes, it tries to progressively
     * increase the limit in `this.#increaseLimit` until another call is made to
     * `this.rateLimit`.
     * Call this function when using the RateLimitedQueue for network requests and
     * the remote server responds with 429 HTTP code.
     *
     * @param {number} duration in milliseconds.
     */

  }, {
    key: "rateLimit",
    value: function rateLimit(duration) {
      clearTimeout(_classPrivateFieldLooseBase(this, _rateLimitingTimer)[_rateLimitingTimer]);
      this.pause(duration);

      if (this.limit > 1 && Number.isFinite(this.limit)) {
        _classPrivateFieldLooseBase(this, _upperLimit)[_upperLimit] = this.limit - 1;
        this.limit = _classPrivateFieldLooseBase(this, _downLimit)[_downLimit];
        _classPrivateFieldLooseBase(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase(this, _increaseLimit)[_increaseLimit], duration);
      }
    }
  }, {
    key: "isPaused",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _paused)[_paused];
    }
  }]);

  return RateLimitedQueue;
}();

function _call2(fn) {
  var _this3 = this;

  _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] += 1;
  var _done = false;
  var cancelActive;

  try {
    cancelActive = fn();
  } catch (err) {
    _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] -= 1;
    throw err;
  }

  return {
    abort: function abort() {
      if (_done) return;
      _done = true;
      _classPrivateFieldLooseBase(_this3, _activeRequests)[_activeRequests] -= 1;
      cancelActive();

      _classPrivateFieldLooseBase(_this3, _queueNext)[_queueNext]();
    },
    done: function done() {
      if (_done) return;
      _done = true;
      _classPrivateFieldLooseBase(_this3, _activeRequests)[_activeRequests] -= 1;

      _classPrivateFieldLooseBase(_this3, _queueNext)[_queueNext]();
    }
  };
}

function _queueNext2() {
  var _this4 = this;

  // Do it soon but not immediately, this allows clearing out the entire queue synchronously
  // one by one without continuously _advancing_ it (and starting new tasks before immediately
  // aborting them)
  queueMicrotask(function () {
    return _classPrivateFieldLooseBase(_this4, _next)[_next]();
  });
}

function _next2() {
  if (_classPrivateFieldLooseBase(this, _paused)[_paused] || _classPrivateFieldLooseBase(this, _activeRequests)[_activeRequests] >= this.limit) {
    return;
  }

  if (_classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].length === 0) {
    return;
  } // Dispatch the next request, and update the abort/done handlers
  // so that cancelling it does the Right Thing (and doesn't just try
  // to dequeue an already-running request).


  var next = _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].shift();

  var handler = _classPrivateFieldLooseBase(this, _call)[_call](next.fn);

  next.abort = handler.abort;
  next.done = handler.done;
}

function _queue2(fn, options) {
  var _this5 = this;

  if (options === void 0) {
    options = {};
  }

  var handler = {
    fn: fn,
    priority: options.priority || 0,
    abort: function abort() {
      _classPrivateFieldLooseBase(_this5, _dequeue)[_dequeue](handler);
    },
    done: function done() {
      throw new Error('Cannot mark a queued request as done: this indicates a bug');
    }
  };

  var index = _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].findIndex(function (other) {
    return handler.priority > other.priority;
  });

  if (index === -1) {
    _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].push(handler);
  } else {
    _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].splice(index, 0, handler);
  }

  return handler;
}

function _dequeue2(handler) {
  var index = _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].indexOf(handler);

  if (index !== -1) {
    _classPrivateFieldLooseBase(this, _queuedHandlers)[_queuedHandlers].splice(index, 1);
  }
}

module.exports = {
  RateLimitedQueue: RateLimitedQueue,
  internalRateLimitedQueue: Symbol('__queue')
};